import React from "react"
import { HomeIcon } from "@heroicons/react/16/solid"

export default function HomeIconButton({onClick}) {
    return (
        <button className="flex items-center justify-start p-4 transition-colors duration-300"
                onClick={onClick}>
            <HomeIcon className="w-6 h-6"/>
        </button>
    )
}